import React, { useEffect } from "react";

function Layout({ title, children }) {
  useEffect(() => {
    document.title = title;
  }, []);
  return <div>{children}</div>;
}
export default Layout;
